import React from 'react'
import { usePopUpContext } from '../../../providers/PopUpProvider'
import PopUpBox from '../PopUpBox'
import NotifyForm from './NotifyForm'
import useWmoEnabled from '../../../../../hooks/useWmoEnabled'

const NotifyOutOfStock = () => {
  const {
    showOosNotifyForm,
    shouldShowOosNotifyForm,
  } = usePopUpContext()

  const isWmoEnabled = useWmoEnabled()
  if (isWmoEnabled) {
    return <NotifyForm />
  }

  return (
    <PopUpBox
      showPopup={showOosNotifyForm}
      shouldShowPopup={shouldShowOosNotifyForm}
    >
      <NotifyForm />
    </PopUpBox>
  )
}

export default NotifyOutOfStock
